export default __webpack_public_path__ + "static/media/discord.654a0df0.svg";